import { ChoiceCard } from '@eventbrite/design-ops-ds';
import { gettext } from '@eventbrite/i18n';
import React, { useMemo } from 'react';
import { SeriesDatesScopedProps } from '../../../../types';
import { getFormattedDateCard } from '../../../utils/localizedDates';
import './ChildEventsSlider.scss';

type ChildEventsSliderProps = Array<{
    value: string;
    url: string;
    display: {
        weekDay: string;
        fullWeekDay: string;
        monthAndDay: string;
        time: string;
    };
    isCurrentListing: boolean;
}>;

const CHILD_EVENTS_THRESHOLD = 7;

// Noop function to give to the ChoiceCard card component the behavior of a clickable element
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => undefined;

const MoreOptionsButton = () => (
    <ChoiceCard onClick={noop}>
        <button className="event-date-card__button">
            {gettext('More options')}
        </button>
    </ChoiceCard>
);

export const ChildEventsSlider = (props: SeriesDatesScopedProps) => {
    const { childEvents, isOnlineEvent, eventId } = props;
    const filteredEventDates: ChildEventsSliderProps = useMemo(() => {
        const eventDates = [];
        const slicedEventDates = childEvents.slice(0, CHILD_EVENTS_THRESHOLD);

        for (let i = 0; i < slicedEventDates.length; i++) {
            const item = childEvents[i];

            eventDates.push({
                value: item.id,
                url: item.url,
                display: getFormattedDateCard({
                    date: item.start,
                    isOnlineEvent,
                    locale: item.locale,
                }),
                isCurrentListing: item.id === eventId,
            });
        }
        return eventDates;
    }, [childEvents, isOnlineEvent, eventId]);

    const childEventsCards = filteredEventDates.map(
        ({ value, display, url, isCurrentListing }) => {
            const { fullWeekDay, weekDay, monthAndDay, time } = display;
            return (
                <li className="event-date-card" key={value}>
                    {/* eslint-disable-next-line @typescript-eslint/no-empty-function */}
                    <ChoiceCard
                        className="event-date-card-inner"
                        selected={isCurrentListing}
                        onClick={noop}
                    >
                        <a
                            className={
                                isCurrentListing
                                    ? 'event-date-card--selected'
                                    : ''
                            }
                            href={url}
                        >
                            <abbr
                                title={fullWeekDay}
                                className="event-date-card__week-day"
                            >
                                {weekDay}
                            </abbr>
                            <span className="event-date-card__month-day">
                                {' '}
                                {monthAndDay}
                            </span>
                            <span className="event-date-card__time">
                                {' '}
                                {time}
                            </span>
                        </a>
                    </ChoiceCard>
                </li>
            );
        },
    );

    return (
        <ul className="event-dates" data-testid="child-events-slider">
            {childEventsCards}
            {childEvents.length > CHILD_EVENTS_THRESHOLD && (
                <li className="event-date-card">
                    <MoreOptionsButton />
                </li>
            )}
        </ul>
    );
};
